import { aadeText } from './aadeText';

//The phone and email a stored company may fill into the checkout's invoice form: real values only. A record
//without them, or the customer-side read (which the companies lockdown answers with ''), gives '' - and the
//caller then keeps what the customer typed or the reopened order carried. The back office files '<afm>@test.mail'
//on a company with no email: that is not an address either.
export const storedCompanyContact = (company) => {
  const phone = aadeText(company?.phone);
  const email = aadeText(company?.email);
  return { phone, email: /@test\.mail$/i.test(email) ? '' : email };
};
